const cities = {
  locale: {
    category: {
      transparent: {
        name: 'Прозорість'
      },
      accountability: {
        name: 'Підзвітність'
      }
    },
  },
  data: [
    {
      id: 'Kyiv',
      name: 'Kyiv',
      url: '#',
      rating: {
        transparent: {
          value: 100,
          place: 3,
          level: 3,
          level_name: 'Прозоре',
          disqualified: true
        },
        accountability: {
          value: 80,
          place: 5
        }
      }
    },
    {
      id: 'Dnipro',
      name: 'Dnipro',
      url: '#',
      rating: {
        transparent: {
          value: 70,
          place: 5,
          level: 3,
          level_name: 'Прозоре',
          disqualified: true
        },
        accountability: {
          value: 20,
          place: 3
        }
      }
    },
    {
      id: 'Odesa',
      name: 'Odesa',
      url: '#',
      rating: {
        transparent: {
          value: 10,
          place: 6,
          level: 1,
          level_name: 'Непрозоре',
          disqualified: false
        },
        accountability: {
          value: 45,
          place: 4
        }
      }
    },
    {
      id: 'Fastiv',
      name: 'Fastiv',
      url: '#',
      rating: {
        transparent: {
          value: 40,
          place: 5,
          level: 2,
          level_name: 'Частково прозоре',
          disqualified: false
        },
        accountability: {
          value: 75,
          place: 8
        }
      }
    },
    {
      id: 'Irpin',
      name: 'Irpin',
      url: '#',
      rating: {
        transparent: {
          value: 40,
          place: 5,
          level: 2,
          level_name: 'Частково прозоре',
          disqualified: false
        },
        accountability: {
          value: 75,
          place: 8
        }
      }
    },
    {
      id: 'Drohobych',
      name: 'Drohobych',
      url: '#',
      rating: {
        transparent: {
          value: 60,
          place: 2,
          level: 3,
          level_name: 'Прозоре',
          disqualified: false
        },
        accountability: {
          value: 35,
          place: 8
        }
      }
    },
    {
      id: 'Sambir',
      name: 'Sambir',
      url: '#',
      rating: {
        transparent: {
          value: 6,
          place: 2,
          level: 1,
          level_name: 'Непрозоре',
          disqualified: true
        },
        accountability: {
          value: 100,
          place: 8
        }
      }
    },
    {
      id: 'Izium',
      name: 'Izium',
      url: '#',
      rating: {
        transparent: {
          value: 43,
          place: 2,
          level: 2,
          level_name: 'Частково прозоре',
          disqualified: false
        },
        accountability: {
          value: 54,
          place: 8
        }
      }
    },
    {
      id: 'Kharkiv',
      name: 'Kharkiv',
      url: '#',
      rating: {
        transparent: {
          value: 31,
          place: 2,
          level: 1,
          level_name: 'Непрозоре',
          disqualified: false
        },
        accountability: {
          value: 98,
          place: 8
        }
      }
    },
    {
      id: 'Dunaivtsi',
      name: 'Dunaivtsi',
      url: '#',
      rating: {
        transparent: {
          value: 21,
          place: 2,
          level: 1,
          level_name: 'Непрозоре',
          disqualified: false
        },
        accountability: {
          value: 68,
          place: 8
        }
      }
    },
    {
      id: 'Starokostiantyniv',
      name: 'Starokostiantyniv',
      url: '#',
      rating: {
        transparent: {
          value: 71,
          place: 2,
          level: 3,
          level_name: 'Прозоре',
          disqualified: false
        },
        accountability: {
          value: 43,
          place: 8
        }
      }
    },
    {
      id: 'Mykolaiv',
      name: 'Mykolaiv',
      url: '#',
      rating: {
        transparent: {
          value: 21,
          place: 2,
          level: 1,
          level_name: 'Непрозоре',
          disqualified: false
        },
        accountability: {
          value: 83,
          place: 8
        }
      }
    }
  ]
}

export default cities;